import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SocialSignIn, safeNext } from "@/components/SocialSignIn";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [params] = useSearchParams();
  const providerError = params.get("error");
  const next = safeNext(params.get("next"));
  const [error, setError] = useState(providerError ? `${providerError === "apple" ? "Apple" : "Google"} sign-in didn't complete. Please try again.` : "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) navigate(next);
    else setError(result.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--brand-bg)] dark:bg-[var(--brand-bg-dark)] px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="font-sacred text-3xl text-[var(--brand-navy)] dark:text-amber-100 tracking-wide">Kindler</h1>
          <p className="font-display italic text-[#686156] dark:text-amber-200/70 mt-2">Enter to prepare your session</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white dark:bg-[var(--brand-card-dark)] border border-[var(--brand-border)] dark:border-[var(--brand-border-dark)] rounded-lg p-8 space-y-5 shadow-sm" data-testid="login-form">
          <SocialSignIn mode="in" next={next} />
          {error && <p className="text-sm text-[var(--brand-crimson)] dark:text-red-400" data-testid="login-error">{error}</p>}
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[var(--brand-crimson)] hover:bg-[var(--brand-crimson-hover)] text-white" data-testid="login-submit-button">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
          <p className="text-sm text-center text-muted-foreground">
            No account yet? <Link to={`/register${next !== "/sessions" ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-[var(--brand-gold-text)] dark:text-[var(--brand-gold)] font-medium" data-testid="login-register-link">Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
